import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login/login.vue'
import Index from '@/pages/index/index.vue'
import Menu from '@/components/menu/menu.vue'
import BusinessData from '@/pages/businessdata/businessdata.vue'
import PowerBankOrder from '@/pages/ordermanagement/powerbankorder.vue'
import OperationRecord from '@/pages/ordermanagement/operationrecord.vue'
import FaultReport from '@/pages/ordermanagement/faultreport.vue'
import StoreDeviceRelation from '@/pages/relation/storedevicerelation.vue'
import CsRelation from '@/pages/relation/csrelation.vue'
import BusinessStoreRelation from '@/pages/relation/businessstorerelation.vue'
import Device from '@/pages/devicemanagement/device.vue'
import PsStore from '@/pages/storemanagement/psstore.vue'
import IwStore from '@/pages/storemanagement/iwstore.vue'
import StoreStatics from '@/pages/storemanagement/storestatics.vue'
import RentUserList from '@/pages/usermanagement/rentuserlist.vue'
import CsManagement from '@/pages/usermanagement/cslist.vue'
import BsManagement from '@/pages/usermanagement/bslist.vue'
import RentUserStatics from '@/pages/usermanagement/rentuserstatics.vue'
import BsStatics from '@/pages/usermanagement/bsstatics.vue'
import CsStatics from '@/pages/usermanagement/csstatics.vue'
import DeviceList from '@/pages/devicemanagement/devicelist.vue'
import WarehouseFramework from '@/pages/warehouse/warehousemanagement/warehouseframework.vue'
import WarehouseList from '@/pages/warehouse/warehousemanagement/warehouselist.vue'
import MyWarehouseList from '@/pages/warehouse/mywarehouse/warehouselist.vue'
import CsDevice from '@/pages/warehouse/mywarehouse/csdevice.vue'
import ApprovalApply from '@/pages/warehouse/apply/approvalapply.vue'
import UsFundsDetail from '@/pages/finance/fundsaccount/usfundsdetail.vue'
import BsFundsDetail from '@/pages/finance/fundsaccount/bsfundsdetail.vue'
import CsFundsDetail from '@/pages/finance/fundsaccount/csfundsdetail.vue'
import BdFundsDetail from '@/pages/finance/fundsaccount/bdfundsdetail.vue'
import PsFundsDetail from '@/pages/finance/fundsaccount/psfundsdetail.vue'
import WithdrawApply from '@/pages/finance/withdrawmanagement/withdrawapply.vue'
import BankManagement from '@/pages/finance/withdrawmanagement/bankmanagement.vue'
import OrderReport from '@/pages/finance/reportmanagement/orderreport.vue'
import CsReport from '@/pages/finance/reportmanagement/csreport.vue'
import CsOrder from '@/pages/finance/reportmanagement/csorder.vue'
import WarehouseDevice from '@/pages/warehouse/warehousedevice/warehousedevice.vue'
import DeviceDistrbution from '@/pages/deviceStatics/deviceDistribution.vue'
import PcManager from '@/pages/sys/pcmanager.vue'
import Position from '@/pages/sys/post.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'Menu',
      component: Menu,
      children: [
        {
          path: '/index',
          name: 'Index',
          component: Index
        },
        {
          path: '/businessData',
          name: 'BusinessData',
          component: BusinessData
        },
        {
          path: '/powerBankOrder',
          name: 'PowerBankOrder',
          component: PowerBankOrder
        },
        {
          path: '/operationRecord',
          name: 'OperationRecord',
          component: OperationRecord
        },
        {
          path: '/faultReport',
          name: 'FaultReport',
          component: FaultReport
        },
        {
          path: '/storeDeviceRelation',
          name: 'StoreDeviceRelation',
          component: StoreDeviceRelation
        },
        {
          path: '/csRelation',
          name: 'CsRelation',
          component: CsRelation
        },
        {
          path: '/bsRelation',
          name: 'BusinessStoreRelation',
          component: BusinessStoreRelation
        },
        {
          path: '/deviceManagement',
          name: 'Device',
          component: Device
        },
        {
          path: '/psStore',
          name: 'PsStore',
          component: PsStore
        },
        {
          path: '/iwStore',
          name: 'IwStore',
          component: IwStore
        },
        {
          path: '/storeStatics',
          name: 'StoreStatics',
          component: StoreStatics
        },
        {
          path: '/rentUserList',
          name: 'RentUserList',
          component: RentUserList
        },
        {
          path: '/csManagement',
          name: 'CsManagement',
          component: CsManagement
        },
        {
          path: '/bsManagement',
          name: 'BsManagement',
          component: BsManagement
        },
        {
          path: '/rentUserStatics',
          name: 'RentUserStatics',
          component: RentUserStatics
        },
        {
          path: '/bsStatics',
          name: 'BsStatics',
          component: BsStatics
        },
        {
          path: '/csStatics',
          name: 'CsStatics',
          component: CsStatics
        },
        {
          path: '/deviceList',
          name: 'DeviceList',
          component: DeviceList
        },
        {
          path: '/warehouseFramework',
          name: 'WarehouseFramework',
          component: WarehouseFramework
        },
        {
          path: '/warehouseList',
          name: 'WarehouseList',
          component: WarehouseList
        },
        {
          path: '/myWarehouseList',
          name: 'MyWarehouseList',
          component: MyWarehouseList
        },
        {
          path: '/csDevice',
          name: 'CsDevice',
          component: CsDevice
        },
        {
          path: '/approvalApply',
          name: 'ApprovalApply',
          component: ApprovalApply
        },
        {
          path: '/usFundsDetail',
          name: 'UsFundsDetail',
          component: UsFundsDetail
        },
        {
          path: '/bsFundsDetail',
          name: 'BsFundsDetail',
          component: BsFundsDetail
        },
        {
          path: '/csFundsDetail',
          name: 'CsFundsDetail',
          component: CsFundsDetail
        },
        {
          path: '/bdFundsDetail',
          name: 'BdFundsDetail',
          component: BdFundsDetail
        },
        {
          path: '/psFundsDetail',
          name: 'PsFundsDetail',
          component: PsFundsDetail
        },
        {
          path: '/withdrawManagement',
          name: 'WithdrawApply',
          component: WithdrawApply
        },
        {
          path: '/bankManagement',
          name: 'BankManagement',
          component: BankManagement
        },
        {
          path: '/orderReport',
          name: 'OrderReport',
          component: OrderReport
        },
        {
          path: '/csReport',
          name: 'CsReport',
          component: CsReport
        },
        {
          path: '/csOrder',
          name: 'CsOrder',
          component: CsOrder
        },
        {
          path: '/warehouseDeviceList',
          name: 'WarehouseDevice',
          component: WarehouseDevice
        },
        {
          path: '/deviceDistrbution',
          name: 'DeviceDistrbution',
          component: DeviceDistrbution
        },
        {
          path: '/managerList',
          name: 'PcManager',
          component: PcManager
        },
        {
          path: '/position',
          name: 'Position',
          component: Position
        }
      ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js